import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useWhatsAppCampaignsBasePath() {
  const location = useLocation();
  return useMemo(
    () =>
      location.pathname.includes('/builder/marketing/')
        ? '/builder/marketing/whatsapp-campaigns'
        : '/builder/sales/whatsapp-campaigns',
    [location.pathname]
  );
}

export function useWhatsAppCampaignActiveTab() {
  const location = useLocation();
  return useMemo(() => {
    if (location.pathname.includes('/whatsapp-campaigns/inbox')) return 'inbox';
    if (location.pathname.includes('/whatsapp-campaigns/media')) return 'media';
    return 'campaigns';
  }, [location.pathname]);
}
